/** @jsx jsx */
import { jsx } from "theme-ui"
// import CookieConsent from "react-cookie-consent"
import { Link } from "gatsby"
import Header from "./header"
import { FaFacebook, FaTiktok } from "react-icons/fa"
// import { useEffect, useState } from "react"

const Footer = () => {
  // const [showCookieConsent, setShowCookieConsent] = useState(false)

  // useEffect(() => {
  //   setTimeout(() => {
  //     setShowCookieConsent(true)
  //   }, 10000)
  // }, [])

  // const handleClickFooterAd = () => {
  //   // eslint-disable-next-line no-undef
  //   const adBtn = document?.getElementById("ad-footer")
  //   // eslint-disable-next-line no-undef
  //   if (window && window.gtag && typeof window.gtag === "function") {
  //     // eslint-disable-next-line no-undef
  //     window.gtag("event", "ad-click", {
  //       event_category: "ad-click",
  //       event_label: adBtn?.querySelector("img")?.title,
  //     })
  //   }
  // }
  return (
    <footer className="site-footer">
      <div className="footer">
        <Header />
      </div>
      <div className="container">
        <a href={`/`} key={"siteURL"} className="footer-brand">
          <h3>
            {`www.${"wyszukiwarkawakacji.pl"}  © ${new Date().getFullYear()}`}
          </h3>
        </a>
        <div sx={{ display: "flex", gap: 3, mt: 2 }}>
          <a
            href="https://www.facebook.com/p/WyszukiwarkaWakacjipl-100083343542329/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "primary",
              "&:hover": { color: "secondary" },
            }}
          >
            <span sx={{ fontSize: 3 }}>
              <FaFacebook sx={{ mr: 1, verticalAlign: "middle" }} /> Facebook
            </span>
          </a>
          <a
            href="https://www.tiktok.com/@wyszukiwarkawakacji"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "primary",
              "&:hover": { color: "secondary" },
            }}
          >
            <span sx={{ fontSize: 3 }}>
              <FaTiktok sx={{ mr: 1, verticalAlign: "middle" }} /> TikTok
            </span>
          </a>
        </div>
      </div>
      <div className="container footer-links">
        <Link className={"footer-link"} to={`/polityka-prywatnosci`}>
          Polityka Prywatności
        </Link>
        {" | "}
        <Link className={"footer-link"} to={`/regulamin`}>
          Regulamin
        </Link>{" "}
        {" | "}
        <Link className={"footer-link"} to={`/rodo`} rel="noopener noreferrer">
          RODO
        </Link>
        {" | "}
        <Link className={"footer-link"} to={`/kontakt`}>
          Kontakt
        </Link>
      </div>
      {/* <a
        className="margin-top-xl"
        onClick={handleClickFooterAd}
        href="https://wyszukiwarkawakacji.pl"
        target="_blank"
        rel="noreferrer sponsored"
      >
        <StaticImage
          src={"../../static/assets/wyszukiwarka_baner.jpg"}
          alt={"baner wyszukiwarkawakacji.pl"}
          className="featured-image"
        />
      </a> */}
      {/* {showCookieConsent && (
        <CookieConsent
          buttonClasses="nety_accept_button"
          buttonText="Zamknij"
          style={{ fontSize: "1em" }}
        >
          <p style={{ fontSize: "1.3em" }}>
            Ten serwis wykorzystuje pliki cookies
          </p>
          <p>
            Serwis wykorzystuje pliki cookies m.in. w celu poprawienia jej
            dostępności, personalizacji, obsługi kont użytkowników czy aby
            zbierać dane, dotyczące ruchu na stronie. Każdy może sam decydować o
            tym czy dopuszcza pliki cookies, ustawiając odpowiednio swoją
            przeglądarkę.
            <br />
            <br />
            Więcej informacji znajdziesz w{" "}
            <a
              href={`/polityka-prywatnosci`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Polityce Prywatności
            </a>{" "}
            i{" "}
            <a href={`/regulamin`} target="_blank" rel="noopener noreferrer">
              Regulaminie
            </a>
            .
          </p>
        </CookieConsent>
      )} */}
    </footer>
  )
}
export default Footer
